import axios from 'axios';
import type { FC, PropsWithChildren } from 'react';
import { useEffect, useRef, useState } from 'react';

import UpdateRequiredModal from './UpdateRequiredModal';

const thirtySecondsInMilliseconds: number = 30000;

interface Props {
  isProduction: boolean;
}

const getLatestApplicationVersion = async (): Promise<number> => {
  try {
    const { data } = await axios.get('/version.json');

    return data.version;
  } catch {
    return -1;
  }
};

const AutomaticAppUpdates: FC<PropsWithChildren<Props>> = ({ children, isProduction }) => {
  const [isDialogVisible, setIsDialogVisible] = useState<boolean>(false);
  const initialVersion = useRef<number | null>(null);

  const handleConfirm = (): void => window.location.reload();

  useEffect(() => {
    if (!isProduction) return;

    const init = async () => {
      initialVersion.current = await getLatestApplicationVersion();
    };

    init();

    const timer = setInterval(async () => {
      if (isDialogVisible || initialVersion.current === null) return;

      const latestVersion = await getLatestApplicationVersion();

      if (latestVersion > initialVersion.current) {
        setIsDialogVisible(true);
      }
    }, thirtySecondsInMilliseconds);

    return () => clearInterval(timer);
  }, [isDialogVisible, isProduction]);

  return (
    <div>
      {children}
      <UpdateRequiredModal isVisible={isDialogVisible} onConfirm={handleConfirm} />
    </div>
  );
};

export default AutomaticAppUpdates;
